export const environment = {
  production: false,
  apiBaseUrl: 'https://api-dev.veralora.com',
};
